var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12ad2b",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M.3 11.4h53.4v17.2H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M.3 0v40l20-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M29.6 14.3 28 19.7l2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m29.6 14.3 1.8 5.4-2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M35 18.2h-5.6v2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m35 18.2-4.6 3.4-1.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m33 24.6-1.8-5.4-2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m33 24.6-4.6-3.3L30 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m26.3 24.6 4.6-3.3-1.7-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m26.3 24.6 1.7-5.4 2.8.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m24.2 18.2 4.6 3.4 1.7-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M24.2 18.2h5.7v2.9m14.5-6.8-1.8 5.4 2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m44.4 14.3 1.7 5.4-2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M49.8 18.2h-5.7v2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m49.8 18.2-4.6 3.4-1.7-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M47.7 24.6 46 19.2l-2.8.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m47.7 24.6-4.6-3.3 1.7-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m41 24.6 4.6-3.3L44 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m41 24.6 1.8-5.4 2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m39 18.2 4.6 3.4 1.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M39 18.2h5.6v2.9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/st.b3a83a63747c425c7ad1a1d3f0a3bc62.svg";
export { ForwardRef as ReactComponent };